import { createFileRoute } from '@tanstack/react-router';

/**
 * /suspended — the terminal screen a user lands on when their account (or their
 * whole company) has been access-suspended by a Regara super-admin. The
 * api-client routes any `access_suspended` (403) response here.
 *
 * Rendered BARE (outside AppShell — see __root.tsx) so it makes no authenticated
 * API calls and therefore can't loop back through the access_suspended redirect.
 */
export const Route = createFileRoute('/suspended')({
  component: SuspendedPage,
});

function SuspendedPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-navy px-4">
      <div className="w-full max-w-md rounded-2xl bg-white shadow-card p-8 text-center">
        <h1 className="font-serif text-[22px] text-navy mb-3">Access suspended</h1>
        <p className="text-[14px] text-slate-600 leading-relaxed">
          Your organization&rsquo;s access to REGARA is currently suspended. Your
          data is safe and unchanged &mdash; access resumes the moment your
          contract is active again.
        </p>
        <p className="text-[13px] text-slate-500 mt-4">
          Please contact your Regara representative to renew.
        </p>
      </div>
    </div>
  );
}
